import { ChatAdapterBuilder, createChatAdapter } from './langchain';
import { ExtendedChatAdapterOptions } from './langchain/langgraph/types/adapterOptions';

export const getAdapterBuilder = <AiMsg>(
  options: ExtendedChatAdapterOptions<AiMsg>
): ChatAdapterBuilder<AiMsg> => {
  const {
    url,
    dataTransferMode,
    headers,
    config,
    inputPreProcessor,
    outputPreProcessor,
    useInputSchema,
    mapActionsProcessor,
  } = options || {};

  if (dataTransferMode && dataTransferMode !== 'stream' && dataTransferMode !== 'batch') {
    throw new Error(`Data transfer mode not supported`);
  }

  if (!url) {
    throw new Error(`Runnable URL is required`);
  }

  let newAdapter = createChatAdapter<AiMsg>().withUrl(url);

  if (dataTransferMode) {
    newAdapter = newAdapter.withDataTransferMode(dataTransferMode);
  }

  if (headers) {
    newAdapter = newAdapter.withHeaders(headers);
  }

  if (config) {
    newAdapter = newAdapter.withConfig(config);
  }

  if (inputPreProcessor) {
    newAdapter = newAdapter.withInputPreProcessor(inputPreProcessor);
  }

  if (outputPreProcessor) {
    newAdapter = newAdapter.withOutputPreProcessor(outputPreProcessor);
  }

  if (mapActionsProcessor) {
    newAdapter = newAdapter.withMapActionsProcessor(mapActionsProcessor);
  }

  if (useInputSchema !== undefined) {
    newAdapter = newAdapter.withInputSchema(useInputSchema);
  }

  return newAdapter;
};
